import { RouteRecordRaw } from 'vue-router';
import LoginView from '~views/LoginView.vue';
import PageNotFound from '~views/PageNotFound.vue';
import DashboardView from '~views/DashboardView.vue';
import StructView from '~views/StructView.vue';
import SessionChecker from '~views/SessionChecker.vue';
import ReferralRequestPage from '@/views/ReferralRequestPage.vue';
import HealthPageFull from '@/views/HealthPageFull.vue';
import PatientDocuments from '@/views/PatientDocuments.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: LoginView,
  },
  {
    path: '/',
    redirect: '/login',
    name: 'home',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guest: true },
  },
  {
    path: '/redirect-login',
    name: 'SessionChecker',
    component: SessionChecker,
    meta: { guest: true },
  },
  {
    path: '/register',
    name: 'RegisterHandler',
    component: ReferralRequestPage,
    props: (route) => ({
      referral: route.query.referral || null,
      id_login: route.query.id_login || null,
    }),
    meta: { guest: true },
  },
  {
    path: '/struct',
    name: 'Struct',
    component: StructView,
    meta: { requiresAuth: true },
  },
  {
    path: '/main',
    name: 'HealthPageFull',
    component: HealthPageFull,
    meta: { requiresAuth: true },
  },
  {
    path: '/patient-documents',
    name: 'PatientDocuments',
    component: PatientDocuments,
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
];

export default routes;
